export const ErrorMessages = {
  tooLongToRespond:
    "לשרת לוקח זמן רב מדי להגיב. נא לבדוק שאתם מחוברים לאינטרנט.",
  youWereLogedOut: "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש.",
};



// WEBPACK FOOTER //
// ./src/app/common/error-handler/error-messages.ts